<template lang="pug">
  div(v-if="this.$route.params.farm_id && this.$route.params.farm_id !== '-1'")
    table.table
      thead.table__header
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          th.table__cell {{ 'base.capacity' | translate }}
          th.table__cell {{ 'base.calibration' | translate }}
          th.table__cell(v-if="isAdmin") Коєфіцієнт калібрування
          th.table__cell(v-if="loaded && !!mixers.length")
      v-table-body(
        :cols="4"
        :loading="!loaded"
        :empty="!mixers.length")
        tr.table__row(
          v-for="item in mixers"
          :key="item.id")
          td.table__cell {{ item.name }}
          td.table__cell {{ item.min_weight }} - {{ item.max_weight }}
          td.table__cell.table__cell--thin
            v-select(
              itemValue="name"
              :disabled="isConsultant || isConsultant"
              :options="getMixerCalibrationOptions(item)"
              :value="getMixerCalibrationLabel(item)"
              @input="onCalibrationChange(item)")
          td.table__cell
            .coef-calibration(v-if="isAdmin")
              span {{ getNeedlessWeight(item) }}
          td.table__cell.table__cell--action
            v-btn(
              v-if="!isConsultant"
              icon
              @click="openMixerDetail(item.id)")
              v-icon(
                font-size="1"
                icon="cog")
    
    //- ui-pagination(
      v-if="loaded"
      :count="totalCount"
      v-model="page"
      @page-change="loadData")

</template>

<script>
import api from '@/api'
import { formatDateUnified } from '@/util'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'MixersTable',

  mounted () {
    this.loadData()
  },

  data: () => ({
    loaded: false
  }),
  watch: {
    '$route.params.farm_id': {
      handler: 'loadData',
      immediate: true
    }
  },
  methods: {
    ...mapActions('mixers', [
      'loadMixers',
      'openMixerDetail'
    ]),

    async loadData () {
      if (!this.$route.params.farm_id || this.$route.params.farm_id === '-1') {
        this.loaded = false
        return
      }
      const params = {
        farm: this.$route.params.farm_id
      // page: this.page
      }
      await this.loadMixers(params)
      this.loaded = true
    },

    async onCalibrationChange (item) {
      const data = {
        calibration: item.calibration,

      }
      const res = await api.mixers.updateCalibration(item.id, data)
      if (res.error) {
        this.$toasted.error(this.$t('error.calibration_change'))
      }
    },

    getMixerCalibrationLabel (mixer) {
      for (const item of mixer.calibrations) {
        if (item.calibration === mixer.calibration) {
          return formatDateUnified(item.created_at, true)
        }
      }
      return '-'
    },
    getNeedlessWeight (item) {
      try {
        if (!item || !item.calibration) return '-'
        const calibrationData = JSON.parse(item.calibration)

        if (calibrationData && calibrationData.units_per_one_kg !== undefined) {
          return calibrationData.units_per_one_kg
        }

        return '-'
      } catch (error) {
        console.error('Error parsing calibration data:', error)
        return '-'
      }
    },
    getMixerCalibrationOptions (mixer) {
      const options = []
      for (const index in mixer.calibrations) {
        const option = {
          id: index,
          mixer: mixer.id,
          calibration: mixer.calibrations[index].calibration,
          name: formatDateUnified(mixer.calibrations[index].created_at, true)
        }
        options.push(option)
      }
      return options
    }
  },

  computed: {
    ...mapGetters('mixers', [
      'mixers'
    ]),

    totalCount () {
      return this.mixers.count !== undefined
        ? this.mixers.count
        : this.mixers.length
    }
  }
}
</script>
